import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CompanyStorageService } from '../company/company.storage';
import { AppServer, CLIENT_IDS, ClientKey } from './client.config';

@Injectable({ providedIn: 'root' })
export class ClientConfigService {
  constructor(private companyStorage: CompanyStorageService) {}

  getCurrentClient(): ClientKey | null {
    const companyId = this.companyStorage.getCompany()?.companyId;
    if (!companyId) {
      return null;
    }

    const env = environment.appServer as AppServer;

    for (const [key, ids] of Object.entries(CLIENT_IDS)) {
      if (ids[env] === companyId) {
        return key as ClientKey;
      }
    }

    return null;
  }

  isClient(client: ClientKey): boolean {
    return this.getCurrentClient() === client;
  }

  isAnyClient(...clients: ClientKey[]): boolean {
    const current = this.getCurrentClient();
    return !!current && clients.includes(current);
  }
}
